import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinpune() {



  const cardData = {
"keyword": "Ertiga on rent in pune",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Ertiga on rent in pune for family trips, outstation journeys, airport transfers, corporate travel, pilgrimage tours, and weekend getaways. Whether you are planning a short city ride or a long-distance journey across Maharashtra and nearby states, our Ertiga cab service ensures a smooth, safe, and stress-free travel experience. With experienced drivers who are well-versed with Pune city routes and highway travel, clean air-conditioned 7-seater vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel solution from Pune. The Maruti Ertiga is ideal for families and small groups due to its spacious seating, comfortable ride quality, and good luggage capacity. With flexible booking options (one-way, round-trip, hourly, and outstation packages), doorstep pickup, easy reservations, and 24/7 customer support, Shivai Travels ensures a comfortable and budget-friendly travel experience.",

"topPlaces": [
 
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for strawberries, scenic viewpoints, and cool climate, ideal for comfortable Ertiga group travel from Pune."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, frequently visited by families and devotees using Ertiga cabs for comfortable darshan trips."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, and religious tourism, making it a popular outstation destination from Pune for Ertiga rentals."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal beach destination near Mumbai known for clean beaches, forts, and resorts, ideal for relaxing Ertiga family trips from Pune."
  },
   {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular hill stations near Pune known for waterfalls, viewpoints, caves, and lush green valleys, making them perfect for Ertiga family trips and weekend getaways."
  },
  {
    "title": "Konkan Beaches (Kashid, Murud, Diveagar)",
    "description":
      "Konkan beaches like Kashid, Murud Janjira, and Diveagar are popular weekend destinations from Pune for scenic coastal drives and beach relaxation."
  },
  {
    "title": "Pune City Tour",
    "description":
      "Ertiga rentals are widely used for Pune city sightseeing covering Shaniwar Wada, Dagdusheth Temple, Aga Khan Palace, and other heritage attractions."
  },
  {
    "title": "Ajanta & Ellora Caves",
    "description":
      "Ajanta and Ellora Caves near Aurangabad are UNESCO World Heritage Sites often visited using Ertiga vehicles for comfortable long-distance heritage tours."
  },
  {
    "title": "Goa Road Trip",
    "description":
      "Goa is one of the most popular long-distance destinations from Pune, and Ertiga is a preferred choice for budget-friendly and comfortable family road trips."
  },
  {
    "title": "Western Ghats Scenic Route",
    "description":
      "The Pune highway routes pass through the Western Ghats offering greenery, ghats, tunnels, and scenic landscapes, making Ertiga travel smooth and enjoyable."
  }
],



services: [
  {
    name: "Ertiga Rental Pune",
    description: "Ertiga rental Pune service provides reliable and comfortable transportation for airport transfers, family trips, business travel, sightseeing tours, and outstation journeys. Spacious Ertiga vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer comfortable seating, air conditioning, and luggage space suitable for family and group travel requirements. Flexible booking options allow convenient Ertiga rental reservations in Pune."
  },
  {
    name: "Pune Ertiga Cab Service",
    description: "Pune Ertiga cab service offers dependable transportation solutions for travelers within Pune and nearby destinations. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient Ertiga cab reservations."
  },
  {
    name: "Ertiga on Hire Pune",
    description: "Ertiga on hire Pune service provides affordable and comfortable travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and airport travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Ertiga hire reservations."
  },
  {
    name: "Maruti Ertiga Taxi Pune",
    description: "Maruti Ertiga taxi Pune service provides quality transportation for passengers seeking comfortable and economical SUV-style travel. Vehicles offer spacious interiors, luggage capacity, and smooth ride quality suitable for tourism, office travel, and personal journeys. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Maruti Ertiga taxi reservations."
  },
  {
    name: "Cheap Ertiga Pune Rent",
    description: "Cheap Ertiga Pune rent service offers economical and comfortable transportation for families, small groups, and tourists traveling within Pune and nearby destinations. Vehicles provide smooth highway travel suitable for one-day tours, airport transfers, and outstation journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost Ertiga reservations."
  },
  {
    name: "Outstation Ertiga Pune Cab",
    description: "Outstation Ertiga Pune cab service provides comfortable transportation for families, corporate teams, and tourists traveling from Pune to outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, business travel, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient outstation Ertiga reservations."
  },
  {
    name: "Ertiga Family Car Rental Pune",
    description: "Ertiga family car rental Pune service offers spacious and economical transportation for travelers planning family tours, sightseeing journeys, and long-distance travel. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for extended travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient family Ertiga reservations."
  },
  {
    name: "Pune Ertiga Booking Service",
    description: "Pune Ertiga booking service provides reliable transportation for local and outstation travel requirements with spacious vehicles and professional drivers. Vehicles ensure smooth city and highway travel suitable for tourism, airport transfers, office travel, and family outings. Professional chauffeurs ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ertiga booking reservations."
  },
  {
    name: "Ertiga One Way Cab Pune",
    description: "Ertiga one way cab Pune service offers comfortable transportation for one-side journeys from Pune to nearby cities and tourist destinations. Vehicles provide spacious seating and luggage space suitable for airport drops, business trips, tourism, and family travel. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-way Ertiga reservations."
  },
  {
    name: "Ertiga Round Trip Pune Taxi",
    description: "Ertiga round trip Pune taxi service offers reliable transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with return options. Vehicles provide comfortable seating and luggage space suitable for families, groups, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip Ertiga reservations."
  },
  {
    name: "Airport Ertiga Pune Cab",
    description: "Airport Ertiga Pune cab service provides complete transportation solutions for airport pickup and drop requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, airport transfers, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient airport Ertiga cab reservations."
  },
  {
    name: "Best Ertiga Rental Pune",
    description: "Best Ertiga rental Pune service offers comfortable and dependable transportation with experienced chauffeurs for local and outstation travel. Vehicles are suitable for business meetings, family trips, airport transfers, sightseeing tours, and personal travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient premium Ertiga rental reservations."
  },
  {
    name: "Ertiga SUV Rental Pune",
    description: "Ertiga SUV rental Pune service provides economical transportation for travelers looking for affordable SUV travel experiences with spacious seating and smooth ride quality. Vehicles are suitable for airport travel, office trips, sightseeing tours, and family outings. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ertiga SUV rental reservations."
  },
  {
    name: "Pune Ertiga with Driver",
    description: "Pune Ertiga with driver service offers reliable and comfortable SUV transportation for local city rides, airport transfers, business travel, and outstation journeys. Vehicles provide spacious seating and smooth travel suitable for families, groups, and solo travelers. Professional drivers ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ertiga with driver reservations."
  },
  {
    name: "Ertiga Group Travel Pune",
    description: "Ertiga group travel Pune service provides spacious and dependable transportation for group outings, family tours, sightseeing trips, and outstation travel from Pune. Vehicles ensure comfortable seating, luggage space, and smooth highway travel suitable for long journeys and weekend trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ertiga group travel reservations."
  }
],

tableData: [
  ["Ertiga Rental Pune", "Pune Ertiga Cab Service"],
  ["Ertiga on Hire Pune", "Maruti Ertiga Taxi Pune"],
  ["Cheap Ertiga Pune Rent", "Outstation Ertiga Pune Cab"],
  ["Ertiga Family Car Rental Pune", "Pune Ertiga Booking Service"],
  ["Ertiga One Way Cab Pune", "Ertiga Round Trip Pune Taxi"],
  ["Airport Ertiga Pune Cab", "Best Ertiga Rental Pune"],
  ["Ertiga SUV Rental Pune", "Pune Ertiga with Driver"],
  ["Ertiga Group Travel Pune", "Ertiga Rental Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Ertiga on Rent in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Ertiga rental service in Pune with professional drivers, comfortable seating, and punctual pickup for smooth and affordable travel experiences."
      },
      {
        WhyChooseheading: "Affordable Ertiga Rental Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Ertiga on rent in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Ertiga Availability",
        WhyChoosedescription: "Our Ertiga rental service in Pune operates 24 hours a day for airport transfers, family tours, corporate travel, weddings, outstation trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Ertiga Cars",
        WhyChoosedescription: "All Ertiga vehicles provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable local and long-distance travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Booking Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Ertiga booking, round-trip travel, airport transfers, local sightseeing, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Ideal MPV for Family & Group Travel",
        WhyChoosedescription: "Ertiga is an ideal vehicle for families, tourists, and corporate travelers with spacious seating, luggage space, comfortable interiors, and smooth highway driving experience."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for City & Outstation Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, Konkan roads, hill stations, and interstate destinations, ensuring safe driving and smooth travel for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Ertiga rental service in Pune?", answer: "Ertiga rental service in Pune provides comfortable MPV taxi transportation for airport transfers, family trips, corporate travel, local sightseeing, and outstation journeys." },
    { question: "Is Ertiga on rent in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Ertiga rental service in Pune." },
    { question: "How many passengers can travel in an Ertiga?", answer: "Ertiga is suitable for 6 to 7 passengers with comfortable seating and luggage space." },
    { question: "Can I book Ertiga for outstation travel?", answer: "Yes, customers can book Ertiga vehicles for local sightseeing, airport transfers, corporate travel, and outstation tours." },
    { question: "Do you provide one-way and round-trip Ertiga service?", answer: "Yes, Shivai Travels provides both one-way and round-trip Ertiga booking services." },
    { question: "Are all Ertiga vehicles air-conditioned?", answer: "Yes, all Ertiga vehicles are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Ertiga on rent in Pune online?", answer: "Yes, customers can easily book Ertiga rental service online or through phone booking." },
    { question: "Do you provide Ertiga for airport and family travel?", answer: "Yes, Shivai Travels provides Ertiga vehicles for airport transfers, family trips, local city rides, and corporate transportation." },
    { question: "Are Ertiga rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Ertiga rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akshay Patil",
      feedback:
        "Booked Ertiga on rent in Pune with Shivai Travels. Comfortable vehicle, smooth journey, and excellent driver support for our family trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Ertiga rental service in Pune. Affordable pricing, clean car, and wonderful travel experience.",
      rating: 5
    }
  ];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga on Rent in Pune",
  "image": "https://shivaitravels.com/assets/images/ertiga-pune.jpg",
  "description": "Book Ertiga on rent in Pune for comfortable family travel, airport transfers, and outstation trips. Shivai Travels offers reliable Ertiga cab service with professional drivers, spacious seating, and affordable pricing for group travel and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shivaitravels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹14/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/ertiga-on-rent-in-pune"
  }
};







  return (
    <div>


<Helmet>
  <title>Ertiga on Rent in Pune | Family SUV Cab Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Ertiga on rent in Pune for family trips, airport transfers, and outstation travel. Comfortable SUV cab service with driver at affordable prices for group travel."
  />

  <meta
    name="keywords"
    content="ertiga rental pune, pune ertiga cab service, ertiga on hire pune, maruti ertiga taxi pune, cheap ertiga pune rent, outstation ertiga pune cab, ertiga family car rental pune, pune ertiga booking service, ertiga one way cab pune, ertiga round trip pune taxi, airport ertiga pune cab, best ertiga rental pune, ertiga suv rental pune, pune ertiga with driver, ertiga group travel pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinpune;